export const statusDarkGreen = "#03A400";
export const statusLightGreen = "rgba(3, 164, 0, 0.54)";

export const statusDarkYellow = "#D99C00";
export const statusLightYellow = "#FFC940";

export const statusDarkRed = "#DD0000";
export const statusLightRed = "#FF4E4E";

export const backgroundDarkGreen = "rgba(3, 164, 0, 0.5)";
export const backgroundDarkYellow = "rgba(217, 156, 0, 0.5)";
export const backgroundDarkRed = "rgba(221, 0, 0, 0.5)";

